import { useState, useEffect, useContext } from "react";

import {
  locationContext,
  addressContext,
} from "../contexts/location context.js";
import { useTranslation } from "react-i18next";
export default function Nav() {
  const [add, setAdd] = useContext(addressContext);
  const { t, i18n } = useTranslation();

  return (
    <div className="nav-bar">
      <h1 className="page-title">{t("Sajdah Serenity")}</h1>
      <div>
        <input
          type="text"
          className="location-input"
          value={add}
          onChange={(e) => {
            setAdd(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
